<template>
  <header>
    <div class="logoBg">
      <img :src="require('../assets/logoLeft.png')" alt="" class="logoLeft" />
      <img :src="require('../assets/logoRight.png')" alt="" class="logoRight" />
      <div class="loginDiv">
        <img :src="require('../assets/login.png')" alt="" />
        <span @click="openLogin = true" v-if="loginStatus != 2">登录</span>
        <el-popover
          placement="bottom"
          width="300"
          trigger="hover"
          v-if="loginStatus == 2"
        >
          <div class="teacherInfoList">
            用户类型：<span v-if="userInfo.schType == 's'">学生</span
            ><span v-if="userInfo.schType == 't'">教工</span>
          </div>
          <div class="teacherInfoList">
            工、学号：{{ userInfo.userJobNumber }}
          </div>
          <div class="teacherInfoList">
            机构：<span v-for="item in userInfo.orgInfos">{{
              item.orgName
            }}</span>
          </div>
          <div class="load">
            <div
              class="teacherbutton"
              style="color: #348f71"
              @click="goMainSys"
            >
              进入系统
            </div>
            <div class="teacherbutton" style="color: #348f71" @click="goOut">
              <a
                :href="
                  '/mainsys/cmsapi/logout.do?siteName=' + siteInfo.siteName
                "
                >退出登录</a
              >
            </div>
          </div>
          <span v-if="loginStatus == 2" slot="reference">{{
            userInfo.name
          }}</span>
        </el-popover>
      </div>
    </div>
    <div class="menuDiv">
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        @select="handleSelect"
        background-color="#13499b"
        active-text-color="#fff"
        text-color="#fff"
      >
        <el-menu-item index="1"
          ><span style="font-weight: 400">首页</span></el-menu-item
        >
        <el-divider
          direction="vertical"
          v-if="navList && navList.length > 0"
        ></el-divider>
        <template v-for="(item, index) in navList">
          <el-menu-item :index="item.id" v-if="!item.children" :key="item.id"
            ><span style="font-weight: 400">{{ item.text }}</span></el-menu-item
          >
          <el-submenu
            :index="item.id"
            v-if="item.children && item.children.length > 0"
            :key="item.id"
          >
            <template slot="title"
              ><span style="font-weight: 400" @click="toList(item.id)">{{
                item.text
              }}</span></template
            >
            <template v-for="(child1,index) in item.children">
              <el-menu-item
                :key="child1.id"
                :index="child1.id"
                v-if="!child1.children"
              >
                <span style="font-weight: 400">{{ child1.text }}</span>
              </el-menu-item>
            </template>
          </el-submenu>
          <el-divider
            direction="vertical"
            :key="item.id"
            v-if="index != navList.length - 1"
          ></el-divider>
        </template>
      </el-menu>
      <el-dialog title="用户登录" :visible.sync="openLogin" width="500px">
        <div style="margin: 0 auto; width: 360px">
          <el-form
            :rules="loginRules"
            ref="loginForm"
            :model="loginForm"
            label-position="top"
            size="small"
            style="width: 360px"
          >
            <el-form-item prop="userName">
              <el-input
                v-model="loginForm.userName"
                placeholder="用户名"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                placeholder="密码"
              ></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <div style="display: flex; width: 100%">
                <el-input
                  v-model="loginForm.code"
                  placeholder="验证码"
                  style="width: 280px"
                ></el-input
                >&nbsp;&nbsp;
                <img
                  id="codeBox"
                  height="28px"
                  width="100px"
                  style="vertical-align: middle; cursor: pointer"
                  border="0"
                  :src="checkCodeSrc"
                  @click="changeCode"
                />
              </div>
            </el-form-item>
            <div style="text-align: center; margin-top: 28px">
              <el-button
                @click="submitLoginInfo"
                class="normolBotton"
                size="small"
                >登录</el-button
              >
              <el-button @click="openLogin = false" size="small"
                >取消</el-button
              >
            </div>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </header>
</template>

<script>
import md5 from "js-md5"; //md5
export default {
  data() {
    return {
      activeIndex: "1",
      navList: [],
      loginStatus: 1, //1-未登录 2-已登录
      userInfo: {}, //用户信息
      childrenIndex:0,
      loginForm: {
        userName: "",
        password: "",
        code: "",
      },
      openLogin: false,
      loginRules: {
        userName: [
          { required: true, message: "请输入登陆名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      checkCodeSrc: this.GlobalConfig.baseUrl + "/login/login_code.jsp", //验证码Url
    };
  },
  methods: {
    handleSelect(menuId) {
      let name = "";
      let idx=''
      this.navList.forEach((item) => {
        if (menuId != item.id) {
          if (item.children && item.children.length > 0) {
            item.children.forEach((val,index) => {
              if (val.id == menuId) {
                name = item.text;
                idx=index
              }
            });
          }
        }
      });
      if (name == "教学资源") {
        this.$router.push({
          path: "ListTeach:menuId",
          name: "ListTeach",
          params: { menuId: menuId, menuIndex:idx},
        });
      } else {
        if (menuId == "1") {
          this.$router.push({
            path: "/",
          });
        } else {
          this.$router.push({
            path: "List:menuId",
            name: "List",
            params: { menuId: menuId, menuIndex:idx},
          });
        }
      }
    },

    toList(menuId,index) {
      this.activeIndex = menuId.toString();
      let name = "";
      let ids = "";
      this.navList.forEach((item) => {
        if (menuId == item.id) {
          name = item.text;
          if (item.children && item.children.length > 0) {
            ids = item.children[0].id;
          } else {
            ids = menuId;
          }
        }
      });
      if (name == "中心动态") {
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: ids,menuIndex:index },
        });
      } else if (name == "教学资源") {
        this.$router.push({
          path: "ListTeach:menuId",
          name: "ListTeach",
          params: { menuId: ids,menuIndex:index },
        });
      } else {
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: ids},
        });
      }
    },
    submitLoginInfo() {
      //提交登陆信息
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          //form data表单提交
          let fd = new FormData();
          fd.append("userName", this.loginForm.userName);
          fd.append("password", md5(this.loginForm.password));
          fd.append("code", this.loginForm.code);
          axios
            .post("/userLogin", fd)
            .then((response) => {
              let data = response.data; //数据
              localStorage.setItem("headStatus", "nav");
              if (data.code > 0) {
                //刷新当前页面
                location.reload();
              } else throw data.code;
            })
            .catch((error) => {
              //console.log(error);
              if (error == -2) {
                this.$message.error("您的账号在审核状态中，请耐心等待");
              } else if (error == -1) {
                this.$message.error("您的账号已被管理员锁定");
              } else if (error == -3) {
                this.$message.error("用户名或密码错误");
              } else if (error == -4) {
                this.$message.error("验证码错误");
              } else {
                this.$message.error("与服务器断连接！");
              }
              this.changeCode();
            });
        } else {
          return false;
        }
      });
    },
    changeCode() {
      let dt = new Date().getTime();
      // document.getElementById('codeBox').src='/login/login_code.jsp?dt='+dt;
      this.checkCodeSrc =
        this.GlobalConfig.baseUrl + "/login/login_code.jsp?dt=" + dt;
      this.loginForm.code = ""; //验证码框置空
    },
    getNavList() {
      axios
        .post("/cmsapi/getSiteFirstMenu")
        .then((res) => {
          if (res.data[0]) this.navList = res.data[0].children;
        })
        .catch((error) => {
          console.log(error);
          // this.$message.error('网络出现问题，请检查网络！');
        });
    },
    goMainSys() {
      //进入主系统
      location.href = this.targetUrl;
    },
    goOut() {
      let fd = new FormData();
      fd.append("siteName", this.siteInfo.siteName);
      axios.post("/cmsapi/logout.do", fd).then((res) => {
        //   this.loginStatus = 1
        // localStorage.clear()
        // sessionStorage.clear()
        // location.reload()
      });
    },
  },
  created() {
    this.$nextTick(() => {
      //获取当前用户登录状态
      axios
        .post("/getUserLoginInfo")
        .then((response) => {
          let data = response.data; //数据
          if (data.code > 0) {
            this.loginStatus = data.code;
            sessionStorage.setItem("loginStatus", data.code);
            sessionStorage.setItem("schType", data.data.schType);
            sessionStorage.setItem("userId", data.data.userId);
            if (data.code == 2) this.userInfo = data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
      this.getNavList();
    });
  },
};
</script>

<style scoped>
header {
  height: 170px;
  width: 100%;
}
.logoBg {
  height: 110px;
  width: 100%;
  background: url("../assets/logoBg.png") no-repeat;
  background-size: cover;
  position: relative;
}
.logoLeft {
  position: absolute;
  left: 64px;
  top: 30px;
}
.logoRight {
  position: absolute;
  right: 200px;
  top: 0px;
}
.loginDiv {
  position: absolute;
  right: 60px;
  top: 40px;
  width: auto;
  padding: 0 8px;
  height: 30px;
  /* opacity: 0.4; */
  background: #ffffff33;
  border: 1px solid #7493c2;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.loginDiv span {
  font-family: MicrosoftYaHei;
  font-size: 15px;
  color: #ffffff;
  letter-spacing: 0;
  margin-left: 6px;
}
.menuDiv {
  height: 59px;
  width: 100%;
  background-color: #13499b;
  border-top: 1px solid #547ab5;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0px solid #409eff !important;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 0px solid #409eff !important;
}
.menuDiv >>> .el-menu {
  display: flex !important;
  justify-content: center !important;
}
.el-menu-item {
  font-size: 18px !important;
}
.menuDiv >>> .el-submenu__title {
  font-size: 18px !important;
}
.menuDiv >>> .el-submenu__title .el-icon-arrow-down {
  display: none !important;
}

.el-divider--vertical {
  height: 18px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 24px 12px 0 12px !important;
}
.teacherInfoList {
  height: auto;
  width: 80%;
  padding-left: 20px;
  padding-top: 10px;
  font-size: 12px;
}
.load {
  height: 35px;
  width: 100%;
  display: flex;
  background-color: #ebebeb;
  justify-content: center;
  margin-top: 10px;
}
.teacherbutton {
  width: 49%;
  height: 100%;
  color: #034da4;
  font-size: 12px;
  text-align: center;
  line-height: 35px;
  cursor: pointer;
}
</style>
